export enum ErrorAction {
  SHOW_MESSAGE_ON_ALERT,
  SHOW_MESSAGE_ON_MODAL,
  HANDLED,
}
